<template>
  <span class="rolling-number inline-block tabular-nums" :class="{ 'rolling-number--pulse': pulse }">{{ text }}</span>
</template>

<script>
function parseDigits(v) {
  if (v == null || v === '') return null
  const s = String(v).replace(/[^\d]/g, '')
  if (s === '') return null
  const n = parseInt(s, 10)
  return Number.isFinite(n) ? n : null
}

function easeOutQuart(t) {
  return 1 - (1 - t) ** 4
}

export default {
  name: 'RollingNumber',
  props: {
    value: { type: [String, Number], required: true },
    /** 从旧值滚到新值的时长（毫秒） */
    duration: { type: Number, default: 520 }
  },
  data() {
    const n = parseDigits(this.value)
    return {
      text: n === null ? String(this.value == null ? '' : this.value) : String(n),
      rafId: null,
      pulse: false,
      reduceMotion: false
    }
  },
  watch: {
    value() {
      this.run()
    }
  },
  mounted() {
    try {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    } catch {
      this.reduceMotion = false
    }
  },
  beforeDestroy() {
    if (this.rafId != null) cancelAnimationFrame(this.rafId)
    this.rafId = null
  },
  methods: {
    applyRaw(v, usePulse) {
      const n = parseDigits(v)
      if (n === null) {
        this.text = v == null ? '' : String(v)
        return
      }
      this.text = String(n)
      if (usePulse) this.bumpPulse()
    },
    bumpPulse() {
      if (this.reduceMotion) return
      this.pulse = true
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.pulse = false
        }, 480)
      })
    },
    run() {
      const target = parseDigits(this.value)
      if (target === null) {
        if (this.rafId != null) cancelAnimationFrame(this.rafId)
        this.rafId = null
        this.applyRaw(this.value, false)
        return
      }

      if (this.reduceMotion) {
        if (this.rafId != null) cancelAnimationFrame(this.rafId)
        this.rafId = null
        this.text = String(target)
        return
      }

      const start = parseDigits(this.text)
      const a = start === null ? target : start
      if (a === target) {
        this.text = String(target)
        return
      }

      if (this.rafId != null) cancelAnimationFrame(this.rafId)
      this.bumpPulse()

      const t0 = performance.now()
      const dur = Math.max(120, this.duration)

      const tick = now => {
        const u = Math.min(1, (now - t0) / dur)
        const v = Math.round(a + (target - a) * easeOutQuart(u))
        this.text = String(v)
        if (u < 1) {
          this.rafId = requestAnimationFrame(tick)
        } else {
          this.text = String(target)
          this.rafId = null
        }
      }
      this.rafId = requestAnimationFrame(tick)
    }
  }
}
</script>

<style scoped>
.rolling-number {
  font-variant-numeric: tabular-nums lining-nums;
}
.rolling-number--pulse {
  animation: rolling-num-jolt 0.48s cubic-bezier(0.33, 1, 0.68, 1);
}
@keyframes rolling-num-jolt {
  0% {
    transform: translateY(0.14em);
    opacity: 0.75;
  }
  55% {
    transform: translateY(-0.04em);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .rolling-number--pulse {
    animation: none;
  }
}
</style>
